const hasIdentificationValue = (value: ?string) =>
  !(value === null || value === undefined || value === '');

const hasIdentificationKey = (obj: Object, key: string) =>
  Object.prototype.hasOwnProperty.call(obj, key);

export const requiredVal = (value) => (!value ? 'Required' : undefined);

// Incomplete pairs (country without #, state without #) are not usable ID.
export const isIdentificationNumberMissing = ({
  alienRegistration,
  passportCountry,
  passportNumber,
  socialSecurityNumber,
  stateIdNumber,
  stateIdOrigin,
}: Object) => {
  const hasDriversLicense =
    hasIdentificationValue(stateIdNumber) &&
    hasIdentificationValue(stateIdOrigin);
  const hasPassport =
    hasIdentificationValue(passportCountry) &&
    hasIdentificationValue(passportNumber);
  const hasSsn = hasIdentificationValue(socialSecurityNumber);
  const hasAlien = hasIdentificationValue(alienRegistration);

  return !hasDriversLicense && !hasPassport && !hasSsn && !hasAlien;
};

// Clears orphan country/state so incomplete pairs do not keep blocking Save.
export const clearIncompleteIdentificationPairs = (
  personalInformation: ?Object,
): ?Object => {
  if (!personalInformation) {
    return personalInformation;
  }

  const next = { ...personalInformation };

  // Only clear keys the payload already carries - forms that never collect
  // passport / state id (minors) must not have them injected.
  if (
    hasIdentificationKey(next, 'passportCountry') &&
    !hasIdentificationValue(next.passportNumber)
  ) {
    next.passportCountry = null;
  }
  if (
    hasIdentificationKey(next, 'stateIdOrigin') &&
    !hasIdentificationValue(next.stateIdNumber)
  ) {
    next.stateIdOrigin = null;
  }

  return next;
};
